import React, { FunctionComponent, ReactNode } from 'react'
import clsx from 'clsx'

import { DEFAULT_GRID_COLUMNS, GUTTER_STATIC, GutterStaticTypes } from './constants'
import styles from './style.module.scss'

export interface GridWallProps {
  columns?: number
  gutter?: GutterStaticTypes
  children: ReactNode
}

export const GridWall: FunctionComponent<GridWallProps> = ({ children, columns = DEFAULT_GRID_COLUMNS, gutter = GUTTER_STATIC.STANDARD }) => {
  const className = clsx(styles.gridWall, styles[`gridWall--${columns}Columns`], styles[`gap--${gutter}`])

  return <div className={className}>{children}</div>
}
